import 'knockout.validation';
import ko from 'knockout';
import {
    IInsurancePolicyProvider,
    ISetPolicyNumberRequest,
    ISetPolicyNumberResponse,
    IStatus,
} from '@/shared/interfaces';
import { R } from '@/Resources.resx';
import { fetch } from '@/shared/fetch';

export class ProfileInsuranceViewModel {
    public provider = ko.observable<IInsurancePolicyProvider>();

    public policyNumber = ko.observable<string | undefined>('');
    public title = ko.observable('');
    public description = ko.observable('');
    public inputLabel = ko.observable('');
    public callToAction = ko.observable('');
    public isSubmitting = ko.observable(false);
    public interactedWithInput = ko.observable(false);

    public showInputField = ko.pureComputed(() => this.useIdentifierField);

    private useIdentifierField = false;

    private validator: KnockoutValidationGroup;

    constructor(provider: IInsurancePolicyProvider, policyNumber?: string) {
        this.provider(provider);

        this.policyNumber.extend({
            required: {
                param: true,
                message: () => {
                    const provider = this.provider();
                    return provider
                        ? provider.IdentifierTerm + ' skal udfyldes'
                        : '';
                },
            },
        });

        this.validator = ko.validatedObservable([this.policyNumber]);

        this.policyNumber(policyNumber);
        this.title(provider.Name);
        this.description(
            policyNumber && provider.PrefilledIdentifierDescription
                ? provider.PrefilledIdentifierDescription
                : provider.Description,
        );
        this.callToAction(provider.CallToAction);
        this.inputLabel(provider.IdentifierTerm);
        this.useIdentifierField = provider.ShowIdentifierField;
    }

    public setPolicyNumber = () => {
        const redirect = () => {
            const urlParams = new URLSearchParams(window.location.search);
            location.href = urlParams.get('returnUrl') || '/p';
        };

        if (!this.useIdentifierField && !this.policyNumber()) {
            this.policyNumber(crypto.randomUUID());
        }
        this.interactedWithInput(true);
        this.policyNumber.clearError();

        if (!this.validator.isValid!()) {
            this.validator.errors!.showAllMessages(true);
            return;
        }

        if (this.isSubmitting()) return;

        this.isSubmitting(true);

        const request: ISetPolicyNumberRequest = {
            Number: this.policyNumber()!,
            InsurancePolicyProviderType:
                this.provider()!.InsurancePolicyProviderType,
        };

        void fetch<IStatus<ISetPolicyNumberResponse>>(
            '/api/insurance/policy-number/set/v2',
            'POST',
            request,
        )
            .then((response): void => {
                if (response.HasErrors) {
                    const message = response.Errors.map((x) => x.Value).join();
                    this.policyNumber.setError(message);
                    this.validator.errors!.showAllMessages(true);
                    this.isSubmitting(false);
                    return;
                }
                redirect();
            })
            .catch((): void => {
                const message = R.ErrorValidatingInsuranceMembership;
                this.policyNumber.setError(message);
                this.validator.errors!.showAllMessages(true);
                this.isSubmitting(false);
            });
    };
}
